
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import eventModel from "@/core/models/share/inviteEvent.interface";
import ListSortByAgreeCountPage from "./participantModalReplayListSortByAgreeCount.vue";
import ListSortByStartTimePage from "./participantModalReplayListSortByStartTime.vue";
import GridPage from "@/components/participant/modal/participantModalReplayGrid.vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "participantReplay",
  components: {
    ListSortByAgreeCountPage: ListSortByAgreeCountPage,
    ListSortByStartTimePage: ListSortByStartTimePage,
    GridPage: GridPage
  },
  props: {
    event: { type: Object as PropType<eventModel | null> }
  },
  setup(props: any, context: any) {
    const { t, locale } = useI18n();

    const tabs = [
      {
        index: 0,
        name: "sortbytime",
        display: t("ByTime")
      },
      {
        index: 1,
        name: "sortbyagree",
        display: t("ByCount")
      }
    ];
    const startDate = ref<string>(new Date().toISOString());
    const selectedTab = ref("sortbytime");

    onMounted(() => {});

    return {
      tabs,
      selectedTab,
      startDate,
      t
    };
  }
});
